import { createFileRoute } from '@tanstack/react-router';
import { ReferralsTab } from '@/features/account-settings/tabs/referrals';

export const Route = createFileRoute('/_authenticated/account-settings/referrals')({
    head: () => ({ meta: [{ title: 'Referrals | promote.fun' }] }),
    component: ReferralsTab,
});
